// 모바일 기기 탐지 유틸리티
export const isMobileDevice = () => {
  // User Agent를 통한 모바일 기기 감지
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // 모바일 기기 패턴 (더 포괄적으로)
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|phone|tablet/i;
  
  // 화면 크기를 통한 모바일 감지
  const isMobileScreen = window.innerWidth <= 768;
  
  // 터치 기기인지 확인
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  // User Agent 기반 모바일 감지
  const isUserAgentMobile = mobileRegex.test(userAgent);
  

  
  // User Agent 또는 화면 크기 중 하나라도 모바일이면 true
  return isUserAgentMobile || isMobileScreen;
};

// 터치 기기 감지
export const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
};

// iOS 기기 감지
export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

// Android 기기 감지
export const isAndroid = () => {
  return /Android/.test(navigator.userAgent);
};

// 태블릿 감지
export const isTablet = () => {
  const userAgent = navigator.userAgent;
  return /iPad/.test(userAgent) || 
         (/Android/.test(userAgent) && !/Mobile/.test(userAgent)) ||
         (window.innerWidth >= 768 && window.innerWidth <= 1024);
};

// QR 코드를 통한 접근인지 확인 (URL 파라미터 체크)
export const isQRCodeAccess = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.has('qr') || urlParams.has('mobile');
};

// 모바일에서 인증 없이 접근 가능한지 확인
export const allowMobileGuestAccess = (pathname) => {
  // 시설물 상세 페이지만 모바일 게스트 접근 허용
  const facilityDetailPattern = /facility-detail\/\d+/; // 더 간단하고 유연하게
  const isMobile = isMobileDevice();
  const isMatchingPath = facilityDetailPattern.test(pathname);
  

  
  return isMobile && isMatchingPath;
}; 